export default __webpack_public_path__ + "static/media/single.a3971440.jpg";